<template>
  <div>
    <v-form @submit.prevent v-model="valid">
      <b class="d-block mb-1"> Tipo de Hospedagem </b>
      <v-btn-toggle
        :value="data.type"
        @change="setKey('type', $event)"
        color="primary"
        class="w-full"
        mandatory
      >
        <v-btn
          v-for="item in hostingTypes"
          :key="item.id"
          :value="item.id"
          class="flex-1"
          :disabled="readonly"
          small
        >
          {{ item.name }}
        </v-btn>
      </v-btn-toggle>

      <v-card
        v-if="data.type.includes('hotel')"
        class="pa-2 mt-4"
        rounded="lg"
        outlined
      >
        <b class="mb-2">Hospedagem em Hotel</b>
        <v-row>
          <v-col cols="12" md="6">
            <v-text-field
              :value="data.hosting_name"
              @input="setKey('hosting_name', $event)"
              label="Nome do Hotel"
              :disabled="readonly"
              outlined
              dense
              hide-details
              :rules="[(v) => !!v || 'Nome do Hotel é obrigatório']"
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              :value="data.start_date"
              @input="setKey('start_date', $event)"
              label="Data de Check-in"
              :disabled="readonly"
              type="date"
              outlined
              dense
              hide-details
              :rules="[(v) => !!v || 'Data de Check-in é obrigatório']"
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              :value="data.end_date"
              @input="setKey('end_date', $event)"
              label="Data de Check-out"
              type="date"
              :disabled="readonly"
              outlined
              dense
              hide-details
              :rules="[(v) => !!v || 'Data de Check-out é obrigatório']"
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              :value="data.total_nights"
              @input="setKey('total_nights', $event, parseInt)"
              label="Total de Noites"
              type="number"
              outlined
              dense
              hide-details
              :disabled="readonly"
              :rules="[(v) => !!v || 'Total de Noites é obrigatório']"
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              :value="data.hotel_price_per_night"
              @input="setKey('hotel_price_per_night', $event, parseFloat)"
              label="Preço da Noite"
              prefix="R$"
              type="number"
              outlined
              dense
              hide-details
              :disabled="readonly"
              :rules="[(v) => !!v || 'Preço da Noite é obrigatório']"
            />
          </v-col>
        </v-row>
      </v-card>

      <v-card
        v-if="data.type.includes('airbnb')"
        class="pa-2 mt-4"
        rounded="lg"
        outlined
      >
        <b class="mb-2">Hospedagem em Airbnb</b>
        <v-row>
          <v-col cols="12" md="6">
            <v-text-field
              :value="data.hosting_name"
              @input="setKey('hosting_name', $event)"
              label="Nome do Airbnb"
              :disabled="readonly"
              outlined
              dense
              hide-details
              :rules="[(v) => !!v || 'Nome do Airbnb é obrigatório']"
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              :value="data.hosting_address"
              @input="setKey('hosting_address', $event)"
              label="Endereço do Airbnb"
              :disabled="readonly"
              outlined
              dense
              hide-details
              :rules="[(v) => !!v || 'Endereço do Airbnb é obrigatório']"
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              :value="data.start_date"
              @input="setKey('start_date', $event)"
              label="Data de Check-in"
              type="date"
              outlined
              dense
              hide-details
              :disabled="readonly"
              :rules="[(v) => !!v || 'Data de Check-in é obrigatório']"
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              :value="data.end_date"
              @input="setKey('end_date', $event)"
              label="Data de Check-out"
              type="date"
              outlined
              dense
              hide-details
              :disabled="readonly"
              :rules="[(v) => !!v || 'Data de Check-out é obrigatório']"
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              :value="data.total_price"
              @input="setKey('total_price', $event, parseFloat)"
              label="Preço Total"
              prefix="R$"
              type="number"
              outlined
              dense
              hide-details
              :disabled="readonly"
              :rules="[(v) => !!v || 'Preço Total é obrigatório']"
            />
          </v-col>
        </v-row>
      </v-card>

      <v-text-field
        :value="data.other_price"
        @input="setKey('other_price', $event, parseFloat)"
        label="Outros custos"
        hint="Apenas relacionados a hospedagem"
        :disabled="readonly"
        prefix="R$"
        class="mt-4"
        outlined
        dense
      />
      <v-textarea
        v-if="data.other_price && data.other_price > 0"
        :value="data.other_description"
        @input="setKey('other_description', $event)"
        label="Descrição dos outros custos"
        :disabled="readonly"
        hide-details
        rows="2"
        outlined
        dense
        :rules="[(v) => !!v || 'Descrição dos outros custos é obrigatório']"
      />
    </v-form>
  </div>
</template>

<script>
const defaultData = () => {
  return {
    type: "hotel",
    // geral
    hosting_name: null,
    hosting_address: null,
    start_date: null,
    end_date: null,

    // hotel
    total_nights: null,
    hotel_price_per_night: null,

    // airbnb
    total_price: null,

    // other
    other_price: null,
    other_description: null,
  };
};

export const manifest = {
  id: "HOSTING",
  name: "Hospedagem",
  icon: "mdi-home",
  description: "Hospedagem",
  defaultData: defaultData,
};

export default {
  name: "HostingEditor",
  props: {
    value: {
      type: Object,
      required: true,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      valid: false,
      hostingTypes: [
        { id: "hotel", name: "Hotel" },
        { id: "airbnb", name: "Airbnb" },
        // { id: "rental", name: "Locação" },
      ],
    };
  },
  methods: {
    setKey(key, value, parse = false) {
      this.data = {
        ...this.data,
        [key]: !value ? value : parse ? parse(value) : value,
      };
    },
    getTotal() {
      let value = 0;

      if (this.data.type.includes("hotel"))
        value += this.data.hotel_price_per_night * this.data.total_nights;
      if (this.data.type.includes("airbnb")) value += this.data.total_price;

      value += this.data.other_price || 0;
      return value;
    },
  },
  watch: {
    valid(value) {
      this.$emit("update:valid", value);
    },
    data: {
      handler(value) {
        this.$emit("update:amount", this.getTotal());
      },
      deep: true,
    },
  },
  computed: {
    data: {
      get() {
        return this.value || defaultData();
      },
      set(value) {
        this.$emit("update", value);
      },
    },
  },
};
</script>
